import { mutations } from "Compare/store/mutations";
import db from "Api/database";
import ApiRequest from "Api/request";
import { bus } from "Util/bus.js";

const request = new ApiRequest();
const productUrl = "/api/product/get?id=";

const actions = {
	async addProductToDb({ commit }, id) {
		await request.getData(`${productUrl}${id}`).then(async (result) => {
			if (result.success) {
				const product = JSON.parse(result.value);
				await db.saveProduct(product);

				const products = await db.getProducts();
				commit(mutations.SET_PRODUCTS.name, products);

				bus.$emit("comparisonAdded", product.name);
			}
		});
	},

	async getProducts({ commit }) {
		let products = await db.getProducts();
		commit(mutations.SET_PRODUCTS.name, products);
	},

	async deleteProductFromDb({ commit }, id) {
		await db.deleteProduct(id);

		const products = await db.getProducts();
		commit(mutations.SET_PRODUCTS.name, products);
	}
};

export { actions };